export enum ExceedanceProbabilityExposureEnum {
    Continuously = 5,
    Likely = 4,
    Possible = 3,
    Unlikely = 2,
    Negligible = 1,
}

export enum FrequencyExposureEnum {
    '80-100% shifts' = 5,
    '60-79% shifts' = 4,
    '40-59% shifts' = 3,
    '20-39% shifts' = 2,
    '<20% shifts' = 1,
}

export const QualitativeMetrics = [
    {
        exposureFrequencyScore: [20, 25],
        likelihoodScore: 5,
        classification: 'Almost Certain',
    },
    {
        exposureFrequencyScore: [15, 19.9],
        likelihoodScore: 4,
        classification: 'Likely',
    },
    {
        exposureFrequencyScore: [10, 14.9],
        likelihoodScore: 3,
        classification: 'Possible',
    },
    {
        exposureFrequencyScore: [5, 9.9],
        likelihoodScore: 2,
        classification: 'Unlikely',
    },
    {
        exposureFrequencyScore: [1, 4.9],
        likelihoodScore: 1,
        classification: 'Rare',
    },
];
